import React from 'react';
import { Box, Card, CardContent, Chip, CircularProgress, Typography } from '@mui/material';
import SmsIcon from '@mui/icons-material/Sms';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import { useLanguage } from '../../../../context/LanguageContext';
import { ChannelType, DefaultTimeslots } from '../types';

interface GlobalSettingsCardProps {
    data: DefaultTimeslots | null;
    loading: boolean;
}

const CHANNEL_ICONS: Record<ChannelType, React.ReactNode> = {
    SMS: <SmsIcon />,
    EMAIL: <AlternateEmailIcon />,
};

const GlobalSettingsCard = ({ data, loading }: GlobalSettingsCardProps) => {
    const { t } = useLanguage();

    return (
        <Card sx={{ mb: 3 }}>
            <CardContent>
                <Typography variant="subtitle1" sx={{ mb: 2 }}>
                    {t('pages.marketing.timeslotsPage.globalSettingsTitle')}
                </Typography>
                {loading ? (
                    <Box display="flex" justifyContent="center" py={3}>
                        <CircularProgress size={28} />
                    </Box>
                ) : (
                    <Box display="flex" flexDirection="column" gap={2}>
                        {(['SMS', 'EMAIL'] as ChannelType[]).map(channel => (
                            <Box key={channel} display="flex" alignItems="center" gap={1.5}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: 36,
                                        height: 36,
                                        borderRadius: '50%',
                                        bgcolor: 'text.primary',
                                        color: 'common.white',
                                    }}
                                >
                                    {CHANNEL_ICONS[channel]}
                                </Box>
                                <Typography variant="body1" color="text.secondary">
                                    {data ? `${data[channel].start_hour} - ${data[channel].end_hour}` : '-'}
                                </Typography>
                                {data?.[channel].is_company_level && (
                                    <Chip
                                        size="small"
                                        variant="outlined"
                                        color="info"
                                        label={t('pages.marketing.timeslotsPage.customized')}
                                    />
                                )}
                            </Box>
                        ))}
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default GlobalSettingsCard;
